export const SHOW_SIDE_CART_QUERY_PARAM = "showSideCart";
export const SHOW_SIDE_CART_QUERY_PARAM_VALUE = "1";
